module.exports = __webpack_public_path__ + "img/ad.1c0ec6d5.svg";